import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/esm/typeof";

var secureStoredData = function secureStoredData(data) {
  return _typeof(data) === 'object' && data !== null ? function (_ref) {
    var credentials = _ref.credentials,
        nextData = _objectWithoutProperties(_ref, ["credentials"]);

    return nextData;
  }(data) : data;
};

export default function createAuthStore(storeKey) {
  return [function () {
    return typeof window !== 'undefined' && window && window.localStorage ? function () {
      var d = window.localStorage.getItem(storeKey); // FIX: JSON.parse throws error for down listed values. Skip them...

      if (d === 'undefined' || d === 'null' || d === '') {
        return null;
      }

      return d ? JSON.parse(d) : null;
    }() : null;
  }, function (data) {
    if (typeof window !== 'undefined' && window && window.localStorage) {
      if (data === undefined || data === null || data === '') {
        // Do not store udefined data. Remove item instead.
        window.localStorage.removeItem(storeKey);
      } else {
        window.localStorage.setItem(storeKey, JSON.stringify(secureStoredData(data)));
      }
    }
  }];
}